import { Logger } from '@/lib/logs/logger';

import { useDeleteOneDraftPlot, useDiscardAllDraftPlots } from './useDraftPlotUploadActions';

type UseDraftPlotBulkActionsParams = {
  organizationId: string | null;
  remainingPlotCount: number;
  onEmpty: () => void;
};

/** Deleting a single draft plot or discarding all of them, resetting the panel once none remain. */
export const useDraftPlotBulkActions = ({
  organizationId,
  remainingPlotCount,
  onEmpty,
}: UseDraftPlotBulkActionsParams) => {
  const { submit: deleteOnePlot } = useDeleteOneDraftPlot();
  const { submit: discardAll, isDiscarding } = useDiscardAllDraftPlots();

  const handleDeleteOne = async (id: string) => {
    try {
      await deleteOnePlot(id);
      if (remainingPlotCount <= 1) onEmpty();
    } catch (error) {
      Logger.errorOnce(error as Error);
    }
  };

  const handleDiscardAll = async () => {
    if (!organizationId) return;
    try {
      await discardAll(organizationId);
      onEmpty();
    } catch (error) {
      Logger.errorOnce(error as Error);
    }
  };

  return { handleDeleteOne, handleDiscardAll, isDiscarding };
};
